import apexInsuranceMappingData from "@/configuration/groups/apex/insurance-mapping.json";
import balanceHealthInsuranceMappingData from "@/configuration/groups/balance-health/insurance-mapping.json";
import cougInsuranceMappingData from "@/configuration/groups/coug/insurance-mapping.json";
import entpInsuranceMappingData from "@/configuration/groups/entpartners/insurance-mapping.json";
import hvcInsuranceMappingData from "@/configuration/groups/hvc/insurance-mapping.json";
import pacesetterInsuranceMappingData from "@/configuration/groups/pacesetter/insurance-mapping.json";
import tricityInsuranceMappingData from "@/configuration/groups/tco/insurance-mapping.json";
import heartplaceInsuranceMappingData from "@/configuration/groups/ushv-heartplace/insurance-mapping.json";
import ushvPimaInsuranceMappingData from "@/configuration/groups/ushv-pima/insurance-mapping.json";
import { getGroupConfigSubdomain } from "@/configuration/paths";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { type Payer } from "@/src/models/payer";

const INSURANCE_MAPPING_PAYER_IDS: Partial<Record<ConfigSubdomain, ReadonlySet<string>>> = Object.freeze({
  [ConfigSubdomain.APEX]: Object.freeze(new Set(Object.keys(apexInsuranceMappingData))),
  [ConfigSubdomain.BALANCE_HEALTH]: Object.freeze(new Set(Object.keys(balanceHealthInsuranceMappingData))),
  [ConfigSubdomain.COUG]: Object.freeze(new Set(Object.keys(cougInsuranceMappingData))),
  [ConfigSubdomain.ENT_PARTNERS]: Object.freeze(new Set(Object.keys(entpInsuranceMappingData))),
  [ConfigSubdomain.USHV_HEARTPLACE]: Object.freeze(new Set(Object.keys(heartplaceInsuranceMappingData))),
  [ConfigSubdomain.HVC]: Object.freeze(new Set(Object.keys(hvcInsuranceMappingData))),
  [ConfigSubdomain.PACESETTER]: Object.freeze(new Set(Object.keys(pacesetterInsuranceMappingData))),
  [ConfigSubdomain.TRICITY]: Object.freeze(new Set(Object.keys(tricityInsuranceMappingData))),
  [ConfigSubdomain.USHV_PIMA]: Object.freeze(new Set(Object.keys(ushvPimaInsuranceMappingData))),
});

export function getInsuranceMappingPayerIds(group: { subdomain: string }): ReadonlySet<string> | null {
  const configSubdomain = getGroupConfigSubdomain(group) as ConfigSubdomain;

  return INSURANCE_MAPPING_PAYER_IDS[configSubdomain] ?? null;
}

function payerIdMatchesAllowedSet(payer: Payer, allowedPayerIds: ReadonlySet<string>): boolean {
  if (payer.primaryPayerId != null && allowedPayerIds.has(payer.primaryPayerId)) {
    return true;
  }

  if (payer.aliases) {
    for (const alias of payer.aliases) {
      if (allowedPayerIds.has(alias)) {
        return true;
      }
    }
  }

  return false;
}

function payerHasCustomerPayerId(payer: Payer, customerPayer: string): boolean {
  return payer.primaryPayerId === customerPayer || (payer.aliases?.includes(customerPayer) ?? false);
}

export function payerMatchesInsuranceMappingAllowlist(
  payer: Payer,
  allowedPayerIds: ReadonlySet<string>,
  currentCustomerPayer?: string | null
): boolean {
  if (currentCustomerPayer != null && currentCustomerPayer !== "") {
    if (payerHasCustomerPayerId(payer, currentCustomerPayer)) {
      return true;
    }
  }

  return payerIdMatchesAllowedSet(payer, allowedPayerIds);
}
